import React from "react"
import { API_ENDPOINTS } from "../../helpers/api"
import { formatDate } from "../../helpers/download"
import ResourceListModal from "./ResourceListModal"
import { aiTierLabel } from "./AiPrompt"

const renderMeta = (favorite) => {
  const parts = [aiTierLabel(favorite.ai_tier), favorite.has_prompt && "has prompt", formatDate(favorite.created_at)]
  return parts.filter(Boolean).join(" · ")
}

const LoadFavoriteModal = ({ onClose, onLoad }) => (
  <ResourceListModal
    title="Load Favorite"
    endpoint={API_ENDPOINTS.FAVORITES}
    listKey="favorites"
    itemKey="favorite"
    emptyText="No saved favorites yet"
    loadingText="Loading saved favorites..."
    renderMeta={renderMeta}
    onLoad={onLoad}
    onClose={onClose}
  />
)

export default LoadFavoriteModal
